<span class="{{ colorClass }} {{ fontClass }}">
  @if (showDate) {
    {{
      date
        | toLuxon: inputTimeZone : dateType
        | luxonTimezone: targetTimezoneOne
        | luxonFormat: dateFormat
    }}
  }
  @if (showTime) {
    {{
      date
        | toLuxon: inputTimeZone : dateType
        | luxonTimezone: targetTimezoneOne
        | luxonFormat: timeFormat
    }}
  }
  @if (showTimeZone) {
    {{
      date
        | toLuxon: inputTimeZone : dateType
        | luxonTimezone: targetTimezoneOne
        | luxonOffsetNameShort
    }}
  }
</span>
